"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_DIACRITICS = void 0;
const tab_1 = require("../../../tab");
exports.REMOVE_DIACRITICS = {
    description: 'Removes diacritics from a string',
    arg_names: ['string', 'remove dangling'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['int', 'boolean', 'number', 'string'],
            required: false,
        },
    ],
    args_description: [
        'a string to remove diacritics from',
        'removes diacritics that are not on letters (default=true)',
    ],
    return_type: tab_1.ColumnType.STRING,
};
